import { customerList } from './../staffManage/partten';
import { COLUMNS, data } from './partten';
export default {
  data() {
    return {
      COLUMNS,
      form: {},
      data,
      customerList,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: data.length,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.form.customerId = this.customerList[0].id;
  },
  methods: {
    getDataFun() {},
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};